import { SelectOption, StaticDataOption } from "../types/staticDataOptions.types";

/** Static-data list → `FormSelect` option list. */
export const toSelectOptions = (staticData: StaticDataOption[] | undefined): SelectOption[] =>
  (staticData ?? []).map(o => ({ value: String(o.value), label: o.text }));

/** Static-data list → id (stringified) → display-label map. */
export const toLabelMap = (staticData: StaticDataOption[] | undefined): Record<string, string> => {
  const map: Record<string, string> = {};
  (staticData ?? []).forEach(o => {
    map[String(o.value)] = o.text;
  });
  return map;
};
